module.exports = tribe.common.icons;